const currencyFormatter = new Intl.NumberFormat(window.navigator.language, {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
});
export default function Currency({value, color=null}) {
    value = isNaN(value) ? 0 : value;
    let style={}
    if(color !== null) {
        style = {'color': color, 'fontWeight': 'bold'}
    }
    return <span style={style}>{currencyFormatter.format(value)}</span>
}